/* ============================================================
   BUNON — Bundle Builder modal
   Cross-product bundle popup used on the PDP and homepage bundle
   band. Self-contained: does not depend on bunon-pdp.js, since
   this file also runs on the homepage.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  var modal = $('#bunon-bundle-modal');
  if (!modal) return;

  var MIN_BUNDLE_QTY = 3;
  var DISCOUNT_PCT = parseFloat(modal.dataset.bundleDiscount3) || 10;

  var BN_DIGITS = { 0: '০', 1: '১', 2: '২', 3: '৩', 4: '৪', 5: '৫', 6: '৬', 7: '৭', 8: '৮', 9: '৯' };
  function bn(num) {
    return Math.round(num).toLocaleString('en-IN').replace(/\d/g, function (d) { return BN_DIGITS[d]; });
  }
  function taka(num) { return '৳' + bn(num); }

  /* ---------- Catalog (lazy-loaded on first open) ---------- */
  var catalog = null;
  var catalogPromise = null;
  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    catalogPromise = fetch('/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        catalog = (data.products || []).map(function (p) {
          var variant = p.variants.filter(function (v) { return v.available; })[0];
          if (!variant) return null;
          return {
            variantId: variant.id,
            productId: p.id,
            title: p.title,
            image: p.images && p.images[0] ? p.images[0].src : null,
            price: parseFloat(variant.price)
          };
        }).filter(Boolean);
        return catalog;
      });
    return catalogPromise;
  }

  /* ---------- Bundle state ---------- */
  /* Map<variantId, {variantId, productId, title, image, price, qty}> */
  var bundle = {};

  function totalQty() {
    var n = 0;
    for (var k in bundle) n += bundle[k].qty;
    return n;
  }
  function subtotal() {
    var n = 0;
    for (var k in bundle) n += bundle[k].qty * bundle[k].price;
    return n;
  }

  /* ---------- Product grid ---------- */
  var grid = $('#bunon-bundle-grid', modal);
  var cardTemplate = $('#bunon-bundle-card-template');
  var cardsByVariant = {};

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function renderCard(product) {
    var node = cardTemplate.content.cloneNode(true);
    var card = node.querySelector('[data-bundle-card]');
    var img = node.querySelector('[data-bundle-card-img]');
    var title = node.querySelector('[data-bundle-card-title]');
    var price = node.querySelector('[data-bundle-card-price]');
    var ribbon = node.querySelector('[data-bundle-card-ribbon]');
    var stepper = node.querySelector('[data-bundle-card-stepper]');
    var minusBtn = node.querySelector('[data-bundle-card-minus]');
    var plusBtn = node.querySelector('[data-bundle-card-plus]');
    var qtyOut = node.querySelector('[data-bundle-card-qty]');

    card.dataset.variantId = product.variantId;
    if (product.image) {
      img.src = product.image;
      img.alt = escapeHtml(product.title);
    } else {
      img.remove();
    }
    title.textContent = product.title;
    price.textContent = taka(product.price);

    function currentQty() {
      return bundle[product.variantId] ? bundle[product.variantId].qty : 0;
    }

    function setQty(qty) {
      qty = Math.max(0, qty);
      if (qty === 0) {
        delete bundle[product.variantId];
        card.classList.remove('in-bundle');
        card.setAttribute('aria-pressed', 'false');
        ribbon.textContent = '+';
        stepper.hidden = true;
      } else {
        bundle[product.variantId] = bundle[product.variantId] || {
          variantId: product.variantId,
          productId: product.productId,
          title: product.title,
          image: product.image,
          price: product.price,
          qty: 0
        };
        bundle[product.variantId].qty = qty;
        card.classList.add('in-bundle');
        card.setAttribute('aria-pressed', 'true');
        ribbon.textContent = '✓';
        stepper.hidden = false;
        qtyOut.textContent = bn(qty);
      }
      renderPreview();
    }

    /* Tapping anywhere on the card toggles bundle membership (add at qty 1,
       or remove entirely) — except the quantity stepper, which is a separate
       control purely for changing how many of this product are in the
       bundle once it's already been added. */
    card.addEventListener('click', function (e) {
      if (e.target.closest('[data-bundle-card-stepper]')) return;
      setQty(currentQty() > 0 ? 0 : 1);
    });
    card.addEventListener('keydown', function (e) {
      if (e.target.closest('[data-bundle-card-stepper]')) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setQty(currentQty() > 0 ? 0 : 1);
      }
    });

    plusBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      setQty(currentQty() + 1);
    });
    minusBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      setQty(currentQty() - 1);
    });

    cardsByVariant[product.variantId] = { card: card, setQty: setQty };
    return node;
  }

  function renderGrid(products) {
    grid.innerHTML = '';
    cardsByVariant = {};
    if (!products.length) {
      var status = document.createElement('p');
      status.className = 'bunon-bundle-grid__status';
      status.setAttribute('data-bn', 'কোনো পণ্য পাওয়া যায়নি');
      status.setAttribute('data-en', 'No products found');
      status.textContent = 'কোনো পণ্য পাওয়া যায়নি';
      grid.appendChild(status);
      return;
    }
    var frag = document.createDocumentFragment();
    products.forEach(function (p) { frag.appendChild(renderCard(p)); });
    grid.appendChild(frag);
    /* re-sync any quantities already chosen before a search re-filtered the grid */
    Object.keys(bundle).forEach(function (variantId) {
      var entry = cardsByVariant[variantId];
      if (entry) entry.setQty(bundle[variantId].qty);
    });
  }

  var searchInput = $('#bunon-bundle-search', modal);
  searchInput && searchInput.addEventListener('input', function () {
    if (!catalog) return;
    var q = searchInput.value.trim().toLowerCase();
    var filtered = q ? catalog.filter(function (p) { return p.title.toLowerCase().indexOf(q) !== -1; }) : catalog;
    renderGrid(filtered);
  });

  /* ---------- Preview panel ---------- */
  var previewList = $('#bunon-bundle-preview-list', modal);
  var previewItemTemplate = $('#bunon-bundle-preview-item-template');
  var subtotalOut = $('[data-bundle-subtotal]', modal);
  var discountRow = $('[data-bundle-discount-row]', modal);
  var discountOut = $('[data-bundle-discount-amount]', modal);
  var totalOut = $('[data-bundle-total]', modal);
  var nudge = $('[data-bundle-nudge]', modal);
  var confirmBtn = $('#bunon-bundle-confirm', modal);
  var countBadge = $('[data-bundle-count]', modal);
  var handleTotalOut = $('[data-bundle-handle-total]', modal);
  var previewPanel = $('[data-bundle-preview]', modal);
  var previewToggle = $('[data-bundle-preview-toggle]', modal);

  previewToggle && previewToggle.addEventListener('click', function () {
    var expanded = previewPanel.classList.toggle('is-expanded');
    previewToggle.setAttribute('aria-expanded', String(expanded));
  });

  function renderPreview() {
    var items = Object.keys(bundle).map(function (k) { return bundle[k]; });
    previewList.innerHTML = '';

    if (!items.length) {
      var empty = document.createElement('li');
      empty.className = 'bunon-bundle-preview__empty';
      empty.setAttribute('data-bn', 'এখনও কিছু বাছাই করা হয়নি');
      empty.setAttribute('data-en', 'Nothing picked yet');
      var lang = document.documentElement.getAttribute('data-lang') || 'bn';
      empty.textContent = lang === 'en' ? 'Nothing picked yet' : 'এখনও কিছু বাছাই করা হয়নি';
      previewList.appendChild(empty);
    } else {
      var frag = document.createDocumentFragment();
      items.forEach(function (item) {
        var node = previewItemTemplate.content.cloneNode(true);
        var img = node.querySelector('[data-bundle-preview-item-img]');
        var title = node.querySelector('[data-bundle-preview-item-title]');
        var qty = node.querySelector('[data-bundle-preview-item-qty]');
        var remove = node.querySelector('[data-bundle-preview-item-remove]');
        if (item.image) { img.src = item.image; img.alt = ''; } else { img.remove(); }
        title.textContent = item.title;
        qty.textContent = '× ' + bn(item.qty);
        remove.addEventListener('click', function () {
          var entry = cardsByVariant[item.variantId];
          if (entry) { entry.setQty(0); } else { delete bundle[item.variantId]; renderPreview(); }
        });
        frag.appendChild(node);
      });
      previewList.appendChild(frag);
    }

    var qty = totalQty();
    var sub = subtotal();
    var qualifies = qty >= MIN_BUNDLE_QTY;
    var discountAmount = qualifies ? sub * (DISCOUNT_PCT / 100) : 0;
    var total = sub - discountAmount;

    subtotalOut.textContent = taka(sub);
    totalOut.textContent = taka(total);
    discountRow.hidden = !qualifies;
    if (qualifies) discountOut.textContent = '−' + taka(discountAmount);
    countBadge.textContent = bn(qty);
    handleTotalOut.textContent = taka(total);

    confirmBtn.disabled = !qualifies;
    if (qualifies) {
      nudge.classList.add('hit');
      nudge.innerHTML = '✓ বান্ডেল ছাড় চালু — বাঁচালেন <b>' + taka(discountAmount) + '</b>';
    } else {
      nudge.classList.remove('hit');
      var remaining = MIN_BUNDLE_QTY - qty;
      nudge.innerHTML = 'আরও <b>' + bn(remaining) + 'টি</b> নিলে <b>' + DISCOUNT_PCT + '%</b> ছাড়';
    }
  }

  /* ---------- Confirm: add all items to cart, tag as bundle, go to cart ---------- */
  confirmBtn.addEventListener('click', function () {
    var items = Object.keys(bundle).map(function (k) { return bundle[k]; });
    if (items.length < 1) return;

    var bundleId = 'bnd_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    var confirmLabel = confirmBtn.querySelector('span');
    var originalLabel = confirmLabel ? confirmLabel.textContent : null;
    confirmBtn.disabled = true;
    if (confirmLabel) confirmLabel.textContent = '···';

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items.map(function (item) {
          return {
            id: item.variantId,
            quantity: item.qty,
            properties: {
              _bundle_id: bundleId,
              _bundle_purchase: 'true'
            }
          };
        })
      })
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && res.body.description || 'Cart error');
        try { sessionStorage.setItem('bunonBundleCod', '1'); } catch (e) {}
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function (err) {
        if (confirmLabel && originalLabel !== null) confirmLabel.textContent = originalLabel;
        renderPreview();
        if (window.bunonToast) {
          window.bunonToast('বান্ডেল কার্টে যোগ করা যায়নি — আবার চেষ্টা করুন');
        }
        if (window.console) console.error('Bunon bundle add-to-cart failed:', err);
      });
  });

  /* ---------- Open / close ---------- */
  var opened = false;
  function openModal() {
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (!opened) {
      opened = true;
      loadCatalog().then(function (products) { renderGrid(products); });
    }
    var closeBtn = $('.bunon-modal__close', modal);
    closeBtn && closeBtn.focus();
  }
  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-bundle-trigger]');
    if (trigger) {
      e.preventDefault();
      openModal();
    }
  });

  var scrim = $('.bunon-modal__scrim', modal);
  var closeBtn = $('.bunon-modal__close', modal);
  scrim && scrim.addEventListener('click', closeModal);
  closeBtn && closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  document.addEventListener('bunonLangChange', function () {
    renderPreview();
  });

  renderPreview();
})();
